import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
    html {
        line-height: htm 1.15;
    }

    .fade-enter {
        opacity: 0.01;
      }

      .fade-enter.fade-enter-active {
        opacity: 1;
        transition: opacity 300ms ease-in;
      }

      .fade-exit {
        opacity: 1;
      }

      .fade-exit.fade-exit-active {
        opacity: 0.01;
        transition: opacity 300ms ease-in;
      }

    .cmu {
        font-family: 'CMUSerifRoman';
    }

    .roboto {
        font-family: Roboto, sans-serif;
    }

    .lb-caption {
        font-family: sans-serif;
    }

    .bg-lighter-gray {
        //background-color: rgba(250, 250, 250, 1);
        background-color: "white";
    }

    .article-width {
        max-width: 90rem;
    }

    .shadow-inner {
        box-shadow: inset 0 0 10px #ddd;
        background-color: rgba(240, 240, 240, 1);
    }

    .large-image {
        height: 300px;
        overflow: hidden;
        margin-bottom: 2.5rem;
    }

    .sidenote {
        display: none;
        opacity: 0;
        transition: opacity .25s;
        -moz-transition: opacity .25s;
        -webkit-transition: opacity .25s;
    }

    .margin-note {
        display: block !important;
        opacity: 1 !important;
    }

    .imagereveal {
        display: none;
        opacity: 0;
        animation: fade 1s;
    }

    .selector {
        cursor: pointer;
    }

    .caption {
        margin-top: -2.5rem;
        padding-top: 1rem;
        padding-bottom: 1rem;
        padding-right: 1rem;
    }

    header {
        transition-duration: 0.25s;
    }

    @media screen and (min-width: 60em) {
        .side {
        margin-right: -75%;
        width: 60%
        }
        .title {
        /* margin-left:-17%; */
        }
    }

    .lora {
        font-family: 'Lora', serif;
    }

    .atlasWidth {
        max-width: 66rem;
    }

    /* 48 originally in tachyons */

    .mw5 {
        max-width: 24rem;
    }

    .mw8 {
        max-width: 80rem;
    }

    .f5 {
        font-size: .925rem;
    }

    a {
        color: #357edd;
    }

    p {
        line-height: 1.5rem;
        margin-bottom: 1.5rem;
        hyphens: auto;
    }

    @media screen and (min-width: 50em) {
        p {
        line-height: 1.7rem;
        margin-bottom: 1.7rem;
        }
    }

    .mw5-ns {
        max-width: 24rem;
    }

    .mw8-ns {
        max-width: 80rem;
    }

    .w-0-ns {
        width: 0%;
    }

    .w-45-ns {
        width: 45%;
    }

    .mw5-m {
        max-width: 24rem;
    }

    .mw8-m {
        max-width: 80rem;
    }

    .mw8-l {
        max-width: 80rem;
    }

    .mh-150 {
        max-height: 150px;
    }

    .mh-300 {
        max-height: 300px;
    }

    .z--1 {
        z-index: -1;
    }

    .react-autosuggest__suggestion--highlighted {
        background-color: #ddd;
    }

    @media screen and (min-width: 116rem) {
        .w-45-sl {
        width: 45%;
        padding-left: 2rem
        }
    }

    @media screen and (min-width: 70em) and (max-width: 116rem) {
        .w-45-sl {
        width: 45%;
        padding-right: 2rem;
        padding-left: 4rem;
        }
    }

    @media screen and (min-width: 50em) and (max-width: 70rem) {
        .w-45-sl {
        width: 45%;
        padding-right: 2rem;
        padding-left: 2rem;
        }
    }

    #root {
        overflow-x: hidden;
    }

    .placeholderColor::placeholder {
        color: rgb(255, 255, 255, 0.6);
    }

    .suggestionsContainerShift {
        left: -1px;
    }

    @media screen and (min-width: 60em) {
        .suggestionsContainerWidth {
            width: 38%;
        }
    }

    /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
    /* Document
    ========================================================================== */

    /**
    * 1. Correct the line height in all browsers.
    * 2. Prevent adjustments of font size after orientation changes in iOS.
    */

    html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
    }

    /* Sections
    ========================================================================== */


    body {
    margin: 0;
    }


    main {
    display: block;
    }

    h1 {
    font-size: 2em;
    margin: 0.67em 0;
    }

    /* Grouping content
    ========================================================================== */

    hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
    }

    pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
    }

    /* Text-level semantics
    ========================================================================== */

    a {
    background-color: transparent;
    }

    abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
    }

    b,
    strong {
    font-weight: bolder;
    }


    code,
    kbd,
    samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
    }


    small {
    font-size: 80%;
    }


    sub,
    sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
    }

    sub {
    bottom: -0.25em;
    }

    sup {
    top: -0.5em;
    }

    /* Embedded content
    ========================================================================== */

    /**
    * Remove the border on images inside links in IE 10.
    */

    img {
    border-style: none;
    }

    /* Forms
    ========================================================================== */

    /**
    * 1. Change the font styles in all browsers.
    * 2. Remove the margin in Firefox and Safari.
    */

    button,
    input,
    optgroup,
    select,
    textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
    }

    /**
    * Show the overflow in IE.
    * 1. Show the overflow in Edge.
    */

    button,
    input { /* 1 */
    overflow: visible;
    }

    /**
    * Remove the inheritance of text transform in Edge, Firefox, and IE.
    * 1. Remove the inheritance of text transform in Firefox.
    */

    button,
    select { /* 1 */
    text-transform: none;
    }

    /**
    * Correct the inability to style clickable types in iOS and Safari.
    */

    button,
    [type="button"],
    [type="reset"],
    [type="submit"] {
    -webkit-appearance: button;
    }

    /**
    * Remove the inner border and padding in Firefox.
    */

    button::-moz-focus-inner,
    [type="button"]::-moz-focus-inner,
    [type="reset"]::-moz-focus-inner,
    [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
    }

    /**
    * Restore the focus styles unset by the previous rule.
    */

    button:-moz-focusring,
    [type="button"]:-moz-focusring,
    [type="reset"]:-moz-focusring,
    [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
    }

    /**
    * Correct the padding in Firefox.
    */

    fieldset {
    padding: 0.35em 0.75em 0.625em;
    }

    legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
    }

    /**
    * Add the correct vertical alignment in Chrome, Firefox, and Opera.
    */

    progress {
    vertical-align: baseline;
    }

    /**
    * Remove the default vertical scrollbar in IE 10+.
    */

    textarea {
    overflow: auto;
    }

    /**
    * 1. Add the correct box sizing in IE 10.
    * 2. Remove the padding in IE 10.
    */

    [type="checkbox"],
    [type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
    }

    /**
    * Correct the cursor style of increment and decrement buttons in Chrome.
    */

    [type="number"]::-webkit-inner-spin-button,
    [type="number"]::-webkit-outer-spin-button {
    height: auto;
    }

    /**
    * 1. Correct the odd appearance in Chrome and Safari.
    * 2. Correct the outline style in Safari.
    */

    [type="search"] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
    }

    /**
    * Remove the inner padding in Chrome and Safari on macOS.
    */

    [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
    }

    ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
    }

    /* Interactive
    ========================================================================== */

    /*
    * Add the correct display in Edge, IE 10+, and Firefox.
    */

    details {
    display: block;
    }

    /*
    * Add the correct display in all browsers.
    */

    summary {
    display: list-item;
    }

    /* Misc
    ========================================================================== */

    /**
    * Add the correct display in IE 10+.
    */

    template {
    display: none;
    }

    /**
    * Add the correct display in IE 10.
    */

    [hidden] {
    display: none;
    }

    /*! TACHYONS v4.11.1 | http://tachyons.io */

    html, body, div, article, aside, section, main, nav, footer, header, form,
    fieldset, legend, pre, code, a, h1, h2, h3, h4, h5, h6, p, ul, ol, li, dl, dt,
    dd, blockquote, figcaption, figure, textarea, table, td, th, tr,
    input[type="email"], input[type="number"], input[type="password"],
    input[type="tel"], input[type="text"], input[type="url"] { box-sizing: border-box; }

    img { width: 100%; max-width: 100%; display: block; }
`

export default GlobalStyle
